export default "__VITE_ASSET__gX5LAITf__";